var jade = require("/var/lib/jenkins/workspace/rel_build_mdm/frontend/client/node_modules/jade/lib/runtime.js");

module.exports = function template(locals) {
var buf = [];
var jade_mixins = {};
var jade_interp;


























jade_mixins["readonly-block"] = jade_interp = function(){
var block = (this && this.block), attributes = (this && this.attributes) || {};
buf.push("<div ng-if=\"vm.isReadonly() || !vm.globalBearbeiten\" ng-show=\"!vm.editMode\" ng-class=\"{'clearfix-hover' : vm.hoverPosition}\" class=\"clearfix box_hover\">");
block && block();
buf.push("</div><div ng-if=\"!vm.isReadonly() &amp;&amp; vm.globalBearbeiten\" ng-show=\"!vm.editMode\" ng-click=\"!vm.isReadonly() &amp;&amp; vm.globalBearbeiten ? vm.toggleEditMode() : null\" data-toggle=\"{{!vm.isReadonly() &amp;&amp; vm.globalBearbeiten ? 'edit' : ''}}\" ng-class=\"{ 'editable' : !vm.isReadonly() &amp;&amp; vm.globalBearbeiten }\" tabindex=\"-1\" class=\"clearfix box_hover\">");
block && block();
buf.push("</div>");
};





































































jade_mixins["vorschau-daten"] = jade_interp = function(vorschau){
var block = (this && this.block), attributes = (this && this.attributes) || {};
buf.push("<div" + (jade.attr("ng-repeat", "(key, val) in " + (vorschau) + "", true, true)) + "><span ng-if=\"val\">{{key}}: {{ val }}</span></div>");
};






jade_mixins["readonly-block"].call({
block: function(){
buf.push("<div class=\"position\"><div>{{vm.idx}}</div><div>{{vm.antragKoFiArt.bez}}<button ng-click=\"vm.toggleStatusInfo()\" ng-class=\"{ 'active': vm.statusInfo }\" type=\"button\" tealium-track=\"info_{{vm.modul.regel.regel_nummer}}\" ng-attr-title=\"Zusatzinformation bezüglich {{vm.idx}} {{vm.antragKoFiArt.bez}} {{vm.statusInfo ? 'ausblenden': 'einblenden'}}\" ng-attr-aria-expanded=\"{{vm.statusInfo}}\" ng-if=\"vm.modul.regel.afr_astbez\" class=\"btn btn-icon toggle-info\"><span class=\"glyphicon glyphicon-info-sign\"></span></button></div><div ng-attr-title=\"{{vm.antragKoFiArt.gekappt?'Der maximale Betrag für diesen Kostenpunkt wurde erreicht.':''}}\"><span ng-if=\"vm.antragKoFiArt.gekappt\" class=\"glyphicon glyphicon-ok text-success\">&nbsp;</span><span>{{vm.getSumme() | currency}}</span></div><div class=\"version\">{{vm.searchInSnapshot(vm.antragKoFiArt.artPk,  vm.antragKoFiArt.diffKey, vm.antragKoFiArt.pk) | currency}}</div><div class=\"procent\"><span ng-if=\"vm.show_prozente()\">{{vm.get_prozent() | number:2 }}&nbsp;%</span></div><div><button ng-click=\"vm.togglePositionen()\" ng-mouseenter=\"vm.changeHoverPosition(true)\" ng-mouseleave=\"vm.changeHoverPosition()\" ng-attr-aria-expanded=\"{{!vm.statusHidePositionen}}\" ng-attr-title=\"{{vm.statusHidePositionen ? 'Positionen zeigen' : 'Positionen verbergen'}} für {{vm.antragKoFiArt.bez}}\" class=\"btn btn-icon toggle-position\"><span>{{vm.statusHidePositionen ? 'Positionen zeigen' : 'Positionen verbergen'}}&nbsp;</span><span ng-class=\" vm.statusHidePositionen ? 'glyphicon-chevron-down' : 'glyphicon-chevron-up' \" class=\"glyphicon\"></span></button></div></div><div ng-show=\"vm.modul.regel.afr_kbez || vm.modul.regel.afr_bezeichnung\" class=\"rules\"><h5 ng-bind-html=\"vm.modul.regel.afr_kbez\"></h5><div ng-bind-html=\"vm.modul.regel.afr_bezeichnung\"></div></div><div ng-show=\"vm.statusInfo\" role=\"alert\" class=\"info\"><button ng-attr-title=\"Zusatzinformation bezüglich {{vm.idx}} {{vm.antragKoFiArt.bez}} {{vm.statusInfo ? 'ausblenden': 'einblenden'}}\" ng-click=\"vm.toggleStatusInfo()\" class=\"btn btn-icon btn-absolute\"><i class=\"glyphicon glyphicon-remove\"></i></button><div ng-bind-html=\"vm.modul.regel.afr_astbez\"></div></div><div ng-hide=\"vm.statusHidePositionen\" class=\"position-detail\"><div ng-repeat=\"p in vm.positionen\" ng-class=\"{'position-version': vm.snapshotPositionClass[p.pk]}\" class=\"position note\"><div><span ng-class=\"vm.snapshotIcons[p.pk]\" ng-if=\"vm.snapshot &amp;&amp; vm.isChanges() &amp;&amp; vm.snapshotIcons[p.pk]\" class=\"glyphicon version-color\"></span><span ng-if=\"vm.idx\">{{vm.idx}}.{{vm.getPosNr(p)}}</span><span ng-if=\"!vm.idx\"></span></div><div>{{vm.getPosBezeichnung(p)}} {{vm.snapshotPositionName[p.pk] ? \"(Vergleichsversion: \" + vm.snapshotPositionName[p.pk] + \")\" : \"\"}}<span ng-if=\"p.posperioden.length &gt; 0\" ng-click=\"vm.showPerioden[p.pk] = !vm.showPerioden[p.pk]\" class=\"ml-2 glyphicon-table\"></span><table ng-if=\"vm.showPerioden[p.pk]\" class=\"table table-sm table-hover\"><thead><tr><th>{{:: vm.gettext(\"_LBL_POSITION_PERIODE_BEZ_\") }}</th><th class=\"text-right\">{{:: vm.gettext(\"_LBL_POSITION_PERIODE_WERT_\") }}</th></tr></thead><tbody><tr ng-repeat=\"per in p.posperioden\"><td>{{:: per.kbez }}</td><td class=\"text-right\">{{:: per.wert | currency}}</td></tr></tbody></table></div><div>{{vm.getPosWert(p) | currency}}</div><div class=\"procent\"></div><div class=\"version\"> {{vm.searchInPositionSnapshot(p,  vm.antragKoFiArt.artPk) | currency}}</div><div ng-if=\"vm.readonly\"></div><div ng-if=\"!vm.readonly\"><button type=\"button\" ng-click=\"vm.toggleEditPosition(p)\" data-toggle=\"edit-note\" class=\"btn btn-icon\"><span class=\"glyphicon glyphicon-pencil\"></span></button><button type=\"button\" dias-confirm confirm-title=\"Position löschen?\" confirm-type=\"danger\" confirm-ok-label=\"Ja\" confirm-ok=\"vm.deletePosition(p)\" class=\"btn btn-default\"><span class=\"glyphicon glyphicon-trash\"></span></button><span class=\"version-span\"></span></div></div><div ng-repeat=\"delPos in vm.showRemovePos(vm.antragKoFiArt.diffKey, vm.antragKoFiArt.pk)\" class=\"position note position-version\"><div><span class=\"glyphicon version-color glyphicon-changes-delete\"></span></div><div>{{delPos.afp_bez || delPos.akp_bez}}</div><div>{{ 0 | currency}}</div><div class=\"version\"> {{delPos.afp_wert || delPos.akp_wert | currency}}</div><div><span class=\"version-span\"></span></div></div></div>");
}
});;return buf.join("");
}